import {
    IMAGE_LIGHTBOX_OPEN,
    IMAGE_LIGHTBOX_CLOSE,
} from '../constants';

export function openImageLightBox(currentImage) {
    return async (dispatch) => {
        dispatch({
            type: IMAGE_LIGHTBOX_OPEN,
            imageLightBox: true,
            currentImage: currentImage ? currentImage : 0
        });

        return true;
    };
}

export function closeImageLightBox() {
    return async (dispatch) => {
        dispatch({
            type: IMAGE_LIGHTBOX_CLOSE,
            imageLightBox: false,
            currentImage: 0
        });

        return true;
    };
}



// WEBPACK FOOTER //
// src/actions/ImageLightBox.js